import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {OrdersStatistic} from '../models/orders-statistic';
import {LoadOrdersStatisticListSuccessAction, ordersStatisticListActionTypes} from '../actions/orders-statistic-list';

export interface OrdersStatisticListState {
  array: OrdersStatistic[];
  count: number;
}

const initialState: OrdersStatisticListState = {
  array: [],
  count: 0,
};

export function OrdersStatisticListReducer(state: OrdersStatisticListState = initialState, action: Action): OrdersStatisticListState {
  switch (action.type) {
    case ordersStatisticListActionTypes.LOAD_SUCCESS:
      return handleLoadOrdersStatisticListSuccessAction(state, action);
    case ordersStatisticListActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    default:
      return state;
  }
}
function handleLoadOrdersStatisticListSuccessAction(state: OrdersStatisticListState, action: LoadOrdersStatisticListSuccessAction): OrdersStatisticListState {
  const newState: OrdersStatisticListState = {
    ... state,
    array: action.payload.array,
    count: action.payload.count
  };
  return newState;
}

function handleLoadErrorActions(state: OrdersStatisticListState): OrdersStatisticListState {
  return state;
}

export const ordersStatisticListStateSelectors = {
  array: (state: OrdersStatisticListState) => _.get(state, 'array', []),
  count: (state: OrdersStatisticListState) => _.get(state, 'count', 0)
};
